import numeral from "numeral";
import React, { useState } from "react";
import { CiWallet } from "react-icons/ci";
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, Col, Divider, Row, Typography } from "antd";
import { useSelector } from "react-redux";
import { useWithdraw } from "hook/finance/withdraw/useWithdraw";
import { defaultWalletAllSelector } from "store/bailiff/default/wallet/default_wallet.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const HistoryWallet = () => {
  // -------------------------- VAR -----------------------------
  const { handleOpen } = useWithdraw();
  // -------------------------- STATE ---------------------------
  const [hide, setHide] = useState(true);
  // -------------------------- REDUX ---------------------------
  const wallet = useSelector(defaultWalletAllSelector);
  const amount = wallet?.earn || 0;
  const labelAmount = numeral(amount).format("0,0");
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBalance = () => {
    const icon = hide ? <EyeOutlined /> : <EyeInvisibleOutlined />;
    const label = hide ? "******" : labelAmount;
    return (
      <div
        style={{
          fontSize: 26,
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          gap: 13,
        }}
      >
        <div>đ {label}</div>
        <Button
          size="middle"
          type="text"
          icon={icon}
          onClick={() => setHide(!hide)}
        />
      </div>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <div style={{ minHeight: 200 }}>
      <Row>
        <Col style={{ padding: 15 }} xl={12} lg={12} md={24} xs={24}>
          <Typography.Title style={{ margin: "10px 0px" }} level={4}>
            <CiWallet style={{ marginRight: 10 }} />
            Ví cá nhân
          </Typography.Title>
          <Typography.Text type="secondary">
            Số dư hiện có trong ví
          </Typography.Text>
        </Col>
        <Col
          style={{
            padding: 15,
            display: "flex",
            alignItems: "end",
            justifyContent: "end",
          }}
          xl={12}
          lg={12}
          md={24}
          xs={24}
        >
          <Button onClick={handleOpen} icon={<PlusOutlined />} type="primary">
            Tạo đơn rút tiền
          </Button>
        </Col>
        <Divider style={{ margin: "5px 0px 10px" }} />
        <Col
          style={{
            padding: 15,
          }}
          xl={12}
          lg={12}
          md={24}
          xs={24}
        >
          {renderBalance()}
        </Col>
      </Row>
    </div>
  );
};
export default HistoryWallet;
